// components/ui/Card.js — neutral surface, no shadow drama.
// Use for sectional panels, list items, and grouped content. Extend via className.
import React from 'react';

export default function Card({ children, className = '', as: Tag = 'div', ...rest }) {
  return (
    <Tag
      className={`bg-surface border border-line rounded-xl ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
